// src/pages/CreateCourse.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createCourse } from '../../../api/teacherApi';
import './CreateCourse.css';

function CreateCourse() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    imageUrl: '',
    zoomLink: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await createCourse(formData);
      setMessage({ 
        type: 'success', 
        text: 'Course created successfully! Redirecting...' 
      });
      
      setTimeout(() => {
        navigate('/teacher/my-courses');
      }, 2000);
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.msg || error.response?.data?.message || 'Error creating course.' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-course">
      <div className="form-header">
        <h1>➕ Create New Course</h1>
        <p>Fill out the form below to create a new course</p>
      </div>

      <form onSubmit={handleSubmit} className="course-form">
        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="title">Course Title *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              required
              placeholder="e.g., React.js Fundamentals"
            />
          </div>

          <div className="form-group">
            <label htmlFor="category">Category</label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="">Select a category</option>
              <option value="Web Development">Web Development</option>
              <option value="Mobile Development">Mobile Development</option>
              <option value="Data Science">Data Science</option>
              <option value="Design">Design</option>
              <option value="Marketing">Marketing</option>
              <option value="Language Learning">Language Learning</option>
              <option value="Leadership">Leadership</option>
            </select>
          </div>

          <div className="form-group full-width">
            <label htmlFor="description">Course Description *</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
              rows="4"
              placeholder="Describe the course content, objectives, and learning outcomes in detail..."
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="imageUrl">Course Image URL</label>
            <input
              type="url"
              id="imageUrl"
              name="imageUrl"
              value={formData.imageUrl}
              onChange={handleChange}
              placeholder="https://example.com/image.jpg"
            />
            {formData.imageUrl && (
              <div className="image-preview">
                <img src={formData.imageUrl} alt="Preview" />
              </div>
            )}
          </div>

          <div className="form-group full-width">
            <label htmlFor="zoomLink">Default Zoom Link</label>
            <input
              type="url"
              id="zoomLink"
              name="zoomLink"
              value={formData.zoomLink}
              onChange={handleChange}
              placeholder="https://zoom.us/j/..."
            />
            <small>Default Zoom link for lessons. Can be overridden for each lesson.</small>
          </div>
        </div>

        {message.text && (
          <div className={`message ${message.type}`}>
            {message.text}
          </div>
        )}

        <div className="form-actions">
          <button 
            type="submit" 
            disabled={loading}
            className="submit-btn"
          >
            {loading ? '⏳ Creating...' : '✅ Create Course'}
          </button>
          <button 
            type="button"
            onClick={() => navigate('/teacher/my-courses')}
            className="cancel-btn"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateCourse;